var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AccountMenu'),_c('AdminSidebar'),_vm._t("default"),_c('NoticeArea')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }